/* eslint-disable indent */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import { Grid, IconButton, makeStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { ParsableDate } from '@material-ui/pickers/constants/prop-types';
import DatePicker from 'components/DatePicker';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import { Formik } from 'formik';
import i18n from 'i18n';
import { getAllClientsRequest } from 'modules/clients/actions';
import { ListClientDataProps } from 'modules/clients/interfaces';
import {
  getAllLogsRequest,
  getEnvironmentRequest,
} from 'modules/environments/actions';
import {
  EnvironmentFields,
  EnvironmentsLogs,
  ListEnvironmentsLogsFieldsDataProps,
} from 'modules/environments/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import GenericForm from 'skyone-lib/lib/GenericForm';
import ApplicationState from 'store/interfaces';
import {
  clearingEmptyFieldsObject,
  formatDateToYearMouthDay,
} from 'utils/helpers';
import { CompanyData, PartnerData } from 'modules/authenticate/interfaces';
import PageTitle from 'components/PageTitle';
import { useTableFilters } from 'hooks/useTableFilters';
import { SearchBar } from 'components/SearchBar';
import styles from './styles';

const useStyles = makeStyles(styles);

const initial = {
  startDate: null,
  endDate: null,
  clientUuid: '',
};

const initialQuery = {
  offset: 0,
  limit: 25,
  search: '',
};

interface Props {
  isLoading: boolean;
  logList: ListEnvironmentsLogsFieldsDataProps;
  environmentSelected: EnvironmentFields | null;
  clientList: ListClientDataProps;
  isLoadingClients: boolean;
  companySelected: CompanyData | null;
  partnerSelected: PartnerData | null;
  getAllLogsRequest: (props) => void;
  getAllClientsRequest: (props) => void;
  getEnvironmentRequest: ({ id, skipProvider }) => void;
}

const LogsEnvironments = ({
  logList,
  isLoading,
  environmentSelected,
  clientList,
  isLoadingClients,
  companySelected,
  partnerSelected,
  getAllLogsRequest,
  getAllClientsRequest,
  getEnvironmentRequest,
}: Props) => {
  const classes = useStyles();

  const {
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
    setQuery,
    query,
    searchValue,
  } = useTableFilters(initialQuery);
  const [minDate, setMinDate] = React.useState<ParsableDate>();
  const { id } = useParams<{ id: string }>();

  const handleSubmit = values => {
    const valuesFormatted = clearingEmptyFieldsObject(values);
    const dataFormat = {
      'cli-uuid': values.client_uuid,
      start_date: formatDateToYearMouthDay(valuesFormatted?.startDate, true),
      end_date: formatDateToYearMouthDay(valuesFormatted?.endDate, true),
    };
    const newQuery =
      values.client_uuid === '-1'
        ? {
            ...query,
            'start-date': dataFormat.start_date,
            'end-date': dataFormat.end_date,
          }
        : {
            ...query,
            'cli-uuid': dataFormat['cli-uuid'],
            'start-date': dataFormat.start_date,
            'end-date': dataFormat.end_date,
          };

    setQuery(newQuery);
  };

  React.useEffect(() => {
    getEnvironmentRequest({ id, skipProvider: true });
  }, [getEnvironmentRequest, id]);

  React.useEffect(() => {
    if (environmentSelected) {
      getAllClientsRequest({
        company_uuid: environmentSelected?.company.uuid,
        environment_uuid: environmentSelected?.environment_uuid,
      });
    }
  }, [
    getAllClientsRequest,
    companySelected,
    environmentSelected,
    partnerSelected,
  ]);

  React.useEffect(() => {
    getAllLogsRequest({ query, id });
  }, [id, query]);

  return (
    <Grid container className={classes.container}>
      <Grid container className={classes.logsTitle}>
        <PageTitle
          title={i18n.t('LOGS_KEY')}
          subtitle={i18n.t('LOGS_LISTING_KEY')}
        />
      </Grid>
      <Formik
        initialValues={initial}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, errors, setFieldValue, submitForm }) => (
          <>
            <Grid item xs={4}>
              <GenericForm
                overrideClasses={{
                  selectLabel: { fontSize: 12, fontWeight: 500 },
                }}
                fields={values}
                screenFields={[
                  {
                    gridXs: 12,
                    label: i18n.t(
                      isLoadingClients
                        ? 'CLIENTS_PAGE.LOADING_LIST_CLIENTES'
                        : 'CLIENT_KEY'
                    ),
                    stateKey: 'client_uuid',
                    isSelect: true,
                    disabled: isLoadingClients,
                    options: [
                      { value: '-1', label: i18n.t('ALL_KEY') },
                      ...clientList.results.map(item => ({
                        value: item?.client_uuid,
                        label: item?.name,
                      })),
                    ],
                  },
                ]}
                setFieldValue={setFieldValue}
                errors={errors}
              />
            </Grid>
            <Grid item xs={4} className={classes.dateContent}>
              <DatePicker
                id="startDate"
                type="date"
                keyValue="startDate"
                setFieldsValue={(key, value) => {
                  setFieldValue(key, value);
                  setMinDate(value);
                }}
                label={i18n.t('START_DATE_KEY')}
                value={values.startDate}
              />
              <DatePicker
                id="endDate"
                type="date"
                keyValue="endDate"
                setFieldsValue={setFieldValue}
                minDate={minDate}
                helperText={i18n.t('DATE_GREATER_THAN_START_DATE_KEY')}
                label={i18n.t('END_DATE_KEY')}
                value={values.endDate}
              />
            </Grid>
            <Grid item xs={1}>
              <IconButton
                id="btn-search"
                onClick={submitForm}
                disabled={isLoading}
              >
                <SearchIcon />
              </IconButton>
            </Grid>
          </>
        )}
      </Formik>

      <Grid container className={classes.table}>
        <SearchBar
          id="search-partners"
          isLoading={isLoading}
          placeholder={i18n.t('ENVIRONMENTS_PAGE.SEARCH_FOR_LOGS')}
          searchValue={searchValue}
          handleSearch={handleSearch}
          setSearchValue={setSearchValue}
        />
        <TableItems
          header={
            <>
              <TableCell centerTitle className={classes.tableRow}>
                {i18n.t('DATE_KEY')}
              </TableCell>
              <TableCell centerTitle className={classes.timeAndType}>
                {i18n.t('TIME_KEY')}
              </TableCell>
              <TableCell centerTitle className={classes.timeAndType}>
                {i18n.t('TYPE_KEY')}
              </TableCell>
              <TableCell>{i18n.t('MESSAGE_KEY')}</TableCell>
            </>
          }
          renderItems={(item: EnvironmentsLogs, index) => (
            <TableRow key={index}>
              <TableCell textAlignCenter centerTitle>
                {item?.date}
              </TableCell>
              <TableCell textAlignCenter centerTitle>
                {item?.time}
              </TableCell>
              <TableCell textAlignCenter centerTitle>
                {item?.type}
              </TableCell>
              <TableCell className={classes.tableMessages}>
                {item?.message}
              </TableCell>
            </TableRow>
          )}
          colCount={5}
          isLoading={isLoading}
          data={logList}
          onChangeLimit={handleLimitChange}
          onChangePage={handlePageChange}
          notFoundText={i18n.t('ENVIRONMENTS_PAGE.NO_LOG_KEY')}
        />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected, partnerSelected },
  environments: { isLoading, logList, environmentSelected },
  clients: { clientList, isLoading: isLoadingClients },
}: ApplicationState) => ({
  companySelected,
  partnerSelected,
  isLoading,
  logList,
  environmentSelected,
  clientList,
  isLoadingClients,
});

export default connect(mapStateToProps, {
  getAllLogsRequest,
  getAllClientsRequest,
  getEnvironmentRequest,
})(LogsEnvironments);
